import useSWR from 'swr';
import { BASE_URI } from '@utils/configPublic';
import { UserProfileApi } from '@pages/api/user/profile';
import { useUserContext } from '@providers/UserProvider';

export function useUserProfile() {
  const { user } = useUserContext();
  const url = `${BASE_URI}/api/user/profile`;
  const res = useSWR<UserProfileApi>(user ? url : undefined);

  return res;
}
